



import { fixedHtmlData, FixedHtmlProperties, ComponentData, fixedHtmlCSS } from "@/services/posts/postTypes/fixedhtml";
import { RenderPostModel } from "@/services/render/types";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setNextItem } from "../types";
import { RuntimeTemplateCompiler } from "vue-runtime-template-compiler";
import { Style } from "@/services/styles/types";

// Components
import TextComponent from "./renderComponents/TextComponent.vue";
import FormatTextComponent from "./renderComponents/FormatTextComponent.vue";
import MacrosComponent from "./renderComponents/MacrosComponent.vue";
import QrcodeComponent from "./renderComponents/QrcodeComponent.vue";
import MediaComponent from "./renderComponents/MediaComponent.vue";

@Component({
    components: {
        mediacomponent: MediaComponent,
        textcomponent: TextComponent,
        formattextcomponent: FormatTextComponent,
        macroscomponent: MacrosComponent,
        qrcodecomponent: QrcodeComponent,
        RuntimeTemplateCompiler
    }
})
export default class FixedHtmlRender extends Vue {
    // passed down from ShiftRender
    @Prop() private item!: RenderPostModel;
    @Prop() private containerWidth!: number;
    @Prop() private containerHeight!: number;
    @Prop() private active!: number;

    // Prop passed down from _StyleForm to preview how the styles looks applied to an example text.
    @Prop() private itemStyle!: Style;
    template = "";
    update = false;
    rerender = false;
    localComponentData = { data: [] as fixedHtmlData[] } as ComponentData;

    setNextItemTimer = 0;
    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0) {
            Vue.set(this.localComponentData, "active", value); // pass post status to the child components, video sub render will use it to play/pause the video
            // we only rerender the RTC component when this post is active
            // if try to rerender/recreate the template with the components when this component is not visible they are lost.
            if (this.rerender) {
                this.rerender = false;
                this.update = !this.update;
            }
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(this.setNextItem, this.localProperties.showTime * 1000);
        }
    }

    @Watch("item", { immediate: true, deep: false })
    onItemChanged(value: RenderPostModel) {
        if (this.template !== this.localProperties.contentTemplate) {
            this.template = this.localProperties.contentTemplate;
            // rerender only if there is a change in the content template
            this.rerender = true;
        }
        // activate reactivity for the data passed to the generated sub-components
        Vue.set(this.localComponentData, "data", this.localProperties.data);
    }

    get localProperties(): FixedHtmlProperties {
        return this.item.properties
            ? (this.item.properties as FixedHtmlProperties)
            : ({} as FixedHtmlProperties);
    }

    // Template should contain exactly one root element
    get wrappedTemplate() {
        return `<div id="template-wrapper">${this.template}</div>`;
    }

    get styleModel(): string {
        const css: any = this.itemStyle ? this.itemStyle.css : this.item.css;
        let style = "";
        if (css) {
            const wrapper = css.wrapper ? css.wrapper : "";
            style = wrapper;
        }
        if (this.containerWidth || this.containerHeight) {
            style += ` width: ${this.containerWidth}px; height: ${this.containerHeight}px; --channel-width: ${this.containerWidth}px; --channel-height: ${this.containerHeight}px;`;
        }

        return style;
    }

    // methods
    setNextItem() {
        this.$emit("setNextItem", { error: false, id: this.item.id } as setNextItem);
    }
}
